import { CommonActivityType } from './common-activity-type.enum';

/**
 * Activity types tracked in the client_activity table.
 * Extends CommonActivityType with Client-specific types.
 */
export const ClientActivityType = {
	...CommonActivityType,

	// Contact management
	CONTACT_ADDED: 'contact_added',
	CONTACT_UPDATED: 'contact_updated',
	CONTACT_DELETED: 'contact_deleted',

	// Address management
	ADDRESS_ADDED: 'address_added',
	ADDRESS_UPDATED: 'address_updated',
	ADDRESS_DELETED: 'address_deleted',

	// Call logs (from client interface)
	CALL_LOGGED: 'call_logged',
	CALL_UPDATED: 'call_updated',
	CALL_DELETED: 'call_deleted',

	// Visits
	VISIT_LOGGED: 'visit_logged',
	VISIT_DELETED: 'visit_deleted',

	// Client operations
	CLIENT_MERGED: 'client_merged',

	// Lifecycle management
	LIFECYCLE_STAGE_CHANGED: 'lifecycle_stage_changed',

	// Watcher management
	WATCHER_ADDED: 'watcher_added',
	WATCHER_REMOVED: 'watcher_removed',

	// Transaction references
	ORDER_CREATED: 'order_created',
	ORDER_SUBMITTED: 'order_submitted',
	ORDER_APPROVED: 'order_approved',
	ORDER_CANCELLED: 'order_cancelled',
	QUOTE_CREATED: 'quote_created',
	QUOTE_UPDATED: 'quote_updated',
	QUOTE_DELETED: 'quote_deleted',
	INVOICE_CREATED: 'invoice_created',
	INVOICE_CANCELLED: 'invoice_cancelled',
	PAYMENT_RECEIVED: 'payment_received',
	PAYMENT_REFUNDED: 'payment_refunded',

	// Related entity changes (cross-entity logging)
	RELATED_OPPORTUNITY_CHANGED: 'related_opportunity_changed',
	RELATED_LICENSE_CHANGED: 'related_license_changed',
	RELATED_ISSUE_CHANGED: 'related_issue_changed',
	RELATED_SOURCING_REQUEST_CHANGED: 'related_sourcing_request_changed',

	// License lifecycle (added 2026-05, PD-13128) — emitted directly from
	// licenses.service.ts + license-match-review.service.ts on the
	// corresponding operations. Distinct from RELATED_LICENSE_CHANGED so
	// the client activity feed surfaces concrete events rather than a
	// generic "something on this license changed".
	LICENSE_CREATED: 'license_created',
	LICENSE_UPDATED: 'license_updated',
	LICENSE_DELETED: 'license_deleted',
	LICENSE_MATCHED: 'license_matched',
	LICENSE_UNMATCHED: 'license_unmatched',

	// AI interactions
	AI_CALL: 'ai_call',

	// Workd Forms (PD-16572): a web form submission linked to this client.
	FORM_SUBMITTED: 'form_submitted',

	// PD-17191: one entry per storefront visit by one of the client's
	// ecommerce users, written when the visit starts. The visit's length,
	// storefront and outcome are read from storefront_visit when the history
	// is listed, so the entry stays current while the visit is in progress.
	STOREFRONT_VISIT: 'storefront_visit',
} as const;

export type ClientActivityType =
	(typeof ClientActivityType)[keyof typeof ClientActivityType];
